import { useRef, useCallback } from 'preact/compat'

export default function useThrottle(callback, interval) {
  const lastRun = useRef(0)

  return useCallback((...args) => {
    const now = Date.now()
    if (now - lastRun.current >= interval) {
      lastRun.current = now
      callback(...args)
    }
  }, [callback, interval])
}